// eslint-disable-next-line
import tw from "twin.macro";
import EnterpriseCard from "../components/Card/EnterpriseCard";
import webIcon from "../icons/WebIcon.svg";
import appIcon from "../icons/AppIcon.svg";
import graphicIcon from "../icons/GraphicIcon.svg";
import writeIcon from "../icons/WriteIcon.svg";
import wave from "../icons/Wave.svg";
import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const EnterpriseData = [
  {
    title: "Web Development",
    price: "3,000",
    icon: webIcon,
    description:
      "We provide user friendly interface of websites coupled with minimalistic design which allows the companies to expand their reach and to have an effective communication with customers.",
    tech: [
      "CMS Development",
      "Ecommerce Development",
      "Node JS Development",
      "Angular Development",
      "React JS Development",
    ],
  },
  {
    title: " App Development",
    price: "3,000",
    icon: appIcon,
    description:
      "We develop compatible and user-friendly apps for android platforms. We help you grow your business. Our team has a well-seasoned team of the developers who have mastered the art of creating intuitive and user-friendly websites.",
    tech: [
      "Android Development",
      "iOS  Development",
      "Flutter Development",
      "React Native Development",
    ],
  },
  {
    title: "Graphic Design",
    price: "3,000",
    icon: graphicIcon,
    description:
      "Our designers know the effective use of visual elements, colors, and graphics while creating a design for your organization. We design visually compelling design with agreat concept behind it.",
    tech: [
      "Logo Designing",
      "Brand Identity Designing",
      "Infographics",
      "Promotional Poster",
    ],
  },
  {
    title: "Content Writing",
    price: "3,000",
    icon: writeIcon,
    description:
      "‘’Content is the king in the market’Our team understands the importance of engaging content to keep the audience onboard with the website/ product.",
    tech: ["Promotional Content", "Web Content", "Web Content", "Web Content"],
  },
];

const EnterpriseSection = () => {
  return (
    <Layout>
      <Seo title="Enterprise" description="We provide the user-friendly interface of websites and apps for android platforms coupled with a minimalistic design. We help you to grow your business. We design visually compelling designs with a great concept behind them. Content is the king in the market our team understands the importance of engaging content to keep the audience on board with the website/ product." />
      <div
        tw="flex flex-col min-h-screen p-4 pt-32 md:pt-10 lg:mt-0  justify-center items-center space-y-20 bg-no-repeat bg-cover bg-right bg-gray-700 text-white"
        style={{ backgroundImage: `url(${wave})` }}
      >
        <div>
          <h1 tw="text-4xl font-bold">Enterprise Service</h1>
        </div>
        <div tw="grid md:grid-cols-2 lg:grid-cols-4  gap-10">
          {EnterpriseData.map((CardName, i) => (
            <EnterpriseCard key={i} {...CardName} />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default EnterpriseSection;
